import { Component } from '@angular/core';
import { AbstractQuestionDirective } from '../abstract-question.directive';

@Component({
  selector: 'app-dropdown-question',
  templateUrl: './dropdown-question.component.html',
  styleUrls: ['./dropdown-question.component.scss'],
})
export class DropdownQuestionComponent extends AbstractQuestionDirective {}
